import { intersection } from "lodash";
import { Group } from "./logger";

const Logger = new Group(`mapColorsToLabel`, { disable: true });

/**
 * Example:
 *
 * renderPieChart() {
 *   const { labels, data } = prepareChartData();
 *   const colors = mapColorsToLabels(labels);
 *   return (
 *     <Pie
 *       data={
 *         labels: labels,
 *         datasets: [{
 *           label: "# Users per device",
 *           backgroundColor: 'rgb(255, 99, 132)',
 *           data: data,
 *         }]
 *       }
 *     />
 *   );
 * }
 */

const COLORS = [
  "#51574a",
  "#447c69",
  "#74c493",
  "#8e8c6d",
  "#e4bf80",
  "#e9d78e",
  "#e2975d",
  "#f19670",
  "#e16552",
  "#c94a53",
  "#be5168",
  "#a34974",
  "#993767",
  "#65387d",
  "#4e2472",
  "#9163b6",
  "#e279a3",
  "#e0598b",
  "#7c9fb0",
  "#5698c4",
  "#9abf88",
];

let labelColors = {}; // colors used for each label

export const mapColorsToLabels = (labels) => {
  labels = labels.map((label) => label.toLowerCase());
  Logger.emit(`Getting colors for`, { table: labels });

  const usedKeys = intersection(Object.keys(labelColors), labels);
  let firstAvailColor = usedKeys.length; // sensible place to start looking for new colors

  const chartColors = [];
  const usedColors = {};

  // get previously used colors for all labels in current report
  usedKeys.forEach((label) => {
    usedColors[labelColors[label]] = true;
  });

  Logger.emit(`usedKeys`, { table: usedKeys });

  labels.forEach((label) => {
    // if we've never seen this label before
    if (!labelColors[label]) {
      while (usedColors[COLORS[firstAvailColor]]) {
        // if we are already using this color, get the next color
        firstAvailColor += 1;
      }
      // if we are not already using this color, save it
      labelColors[label] = COLORS[firstAvailColor];
      firstAvailColor += 1;
    }

    // add color for new label to array that we will push to Chart.js
    chartColors.push(labelColors[label]);
  });

  Logger.emit("Chart Colors", { table: chartColors }).end();

  // return 1D array of colors assigned to current labels
  return chartColors;
};

export default mapColorsToLabels;
